// extracted by mini-css-extract-plugin
export default {"body":"Projects_body__TZ3lO","body__1":"Projects_body__1__Hdm-j","body__2":"Projects_body__2__T-dVJ","body__1__first_p":"Projects_body__1__first_p__k-Udb"};